<template>
  <div class="forgot-wrapper d-flex justify-content-center align-items-center min-vh-100">
    <div class="card p-4 shadow-lg rounded-4 bg-white bg-opacity-75" style="max-width: 400px; width: 100%;">
      <h4 class="text-center mb-3">Reset Password</h4>

      <!-- Input Email -->
      <div class="mb-3">
        <label for="email" class="form-label">Masukkan Email</label>
        <input
          v-model="email"
          @input="validateEmail"
          type="email"
          id="email"
          class="form-control"
          :class="{ 'is-invalid': error }"
        />
        <div class="invalid-feedback" v-if="error">{{ error }}</div>
      </div>

      <!-- Tombol Submit -->
      <button 
        @click="submit" 
        class="btn btn-primary w-100" 
        :disabled="loading || error || !email"
      >
        <span v-if="loading" class="spinner-border spinner-border-sm me-2"></span>
        Reset Password
      </button>

      <div class="text-center mt-3">
        <router-link to="/">⬅ Kembali ke Login</router-link>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import axios from 'axios'
import Swal from 'sweetalert2'
import { useRouter } from 'vue-router'

const email = ref('')
const error = ref('')
const loading = ref(false)
const router = useRouter()

// Validasi format email
const isValidEmail = (email) => {
  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  return regex.test(email)
}

const validateEmail = () => {
  if (!email.value) {
    error.value = 'Email wajib diisi'
  } else if (!isValidEmail(email.value)) {
    error.value = 'Format email tidak valid'
  } else {
    error.value = ''
  }
}

// Submit form reset password
const submit = async () => {
  validateEmail()
  if (error.value) return

  loading.value = true

  try {
    const response = await axios.post('https://metatekapps.metateknologi.com/api-forgot-password.php', {
      email: email.value
    })

    if (response.data.status === 200) {
      await Swal.fire({
        icon: 'success',
        title: 'Berhasil!',
        text: 'Reset password berhasil dikirim ke email Anda.',
        confirmButtonText: 'OK'
      })
      router.push('/') // setelah klik OK, ke login
    } else {
      Swal.fire({
        icon: 'error',
        title: 'Gagal',
        text: response.data.message || 'Permintaan gagal.'
      })
    }
  } catch (err) {
    Swal.fire({
      icon: 'error',
      title: 'Error',
      text: err.response?.data?.message || 'Gagal menghubungi server.'
    })
  } finally {
    loading.value = false
  }
}
</script>

<style scoped>
.forgot-wrapper {
  background: url('https://images.unsplash.com/photo-1504384308090-c894fdcc538d?auto=format&fit=crop&w=1350&q=80') no-repeat center center;
  background-size: cover;
}

.card {
  backdrop-filter: blur(10px);
}
</style>
